import { Grid } from "@material-ui/core";
import React, { useEffect } from "react";
import { TextInput, number, required } from "react-admin";
import { useField } from "react-final-form";

const BoundedTextField = ({ name, label, val, onSet }: any) => {
  const {
    input: { onChange, value },
  } = useField(name);

  useEffect(() => {
    if (!isNaN(value)) {
      onSet && onSet({ type: name, coordinate: value });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    if (val && val !== value) {
      onChange(val);
      onSet && onSet({ type: name, coordinate: val });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [val]);

  return (
    <TextInput
      name={name}
      label={label}
      value={val}
      source={name}
      validate={[required(), number()]}
    />
  );
};

const LatLngInput = ({ lat, lng, updateLatLng }: any) => {
  const latLngStyle = {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "-10px",
    gap: "10px",
  };

  return (
    <>
      <Grid item xs={12} style={latLngStyle}>
        <BoundedTextField
          name="lat"
          label="Latitude"
          val={lat}
          onSet={updateLatLng}
        />
        <BoundedTextField
          name="lng"
          label="Longitude"
          val={lng}
          onSet={updateLatLng}
        />
      </Grid>
    </>
  );
};

export default LatLngInput;
